export default __webpack_public_path__ + "images/PE.5551d25.png";